/* eslint-disable */
import React, { useEffect, useState } from "react"
import { useForm, Controller } from 'react-hook-form';
import TextFieldCustom from '../TextFieldCustom';
import Select from '../Select';
import Button from '../Button';
import { useSubmitForm } from '../../hooks/hook.submit-form';

import provinceItaliane from '../../assets/province-italiane.json';
import FormCittaAmica from "./form.citta-amica"

const FormsPage = ({ setShowThankYouPage, disclaimer }) => {
  const {
    handleSubmit,
    register,
    errors,
    formState,
    control
  } = useForm({ mode: 'onFocus' });

  const { isValid, isSubmitted } = formState;

  const [loadingOnSubmit, setLoadingOnSubmit] = useState({
    label: 'Invia',
    disabled: false
  });

  const onSubmit = (data) => {
    setLoadingOnSubmit({
        label: 'Sto Inviando',
        disabled: true
      }
    );
    useSubmitForm(
      data,
      319,
      () => setShowThankYouPage(true),
      () => {
        setLoadingOnSubmit({
            label: 'Invia',
            disabled: false
          }
        );
        alert('Ops, errore di rete, ritenta l\'invio');
      }
    );
  };

  useEffect(() => {
    setShowThankYouPage(isSubmitted && isValid);
  }, [isSubmitted, isValid]);

  return (
    <form noValidate className="form-group" onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group__container">
        <h3 className="form-group__title heading-md">Baby Pit Stop</h3>

        {/** NAME */}
        <TextFieldCustom
          className="form-group__textfield"
          type="text"
          name="Nome"
          label="Nome"
          error={errors['Nome'] ? errors['Nome'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il nome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** SURNAME */}
        <TextFieldCustom
          className="form-group__textfield"
          type="text"
          label="Cognome"
          name="Cognome"
          error={errors['Cognome'] ? errors['Cognome'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il cognome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** TELEPHONE */}
        <TextFieldCustom
          type="text"
          label="Telefono"
          name="Telefono"
          required
          className="form-group__textfield"
          error={errors['Telefono'] ? errors['Telefono'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        {/** EMAIL */}
        <TextFieldCustom
          className="form-group__textfield"
          type="text"
          label="Email"
          name="Email"
          required
          error={errors['Email'] ? errors['Email'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Formato email non valido'
            }
          })}
        />

        <h4 className="form-group__subtitle heading-md">Dati aggiuntivi/della struttura/del comune/della scuola</h4>
        {/** DENOMINATION */}
        <TextFieldCustom
          type="text"
          name="Denominazione"
          label="Denominazione"
          className="form-group__textfield"
          required
          error={errors['Denominazione'] ? errors['Denominazione'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** DESCRIPTION */}
        <TextFieldCustom
          type="text"
          name="Descrizione_attivita"
          label="Descrizione delle attività"
          className="form-group__textfield"
          required
          error={errors['Descrizione_attivita'] ? errors['Descrizione_attivita'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** ADDRESS */}
        <TextFieldCustom
          type="text"
          name="Indirizzo"
          label="Indirizzo (compreso di civico)"
          className="form-group__textfield"
          required
          error={errors['Indirizzo'] ? errors['Indirizzo'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/* TODO: add "collocazione nella struttura"? */}

        {/** CITY */}
        <TextFieldCustom
          type="text"
          label="Città"
          name="Citta"
          className="form-group__textfield"
          required
          error={errors['Citta'] ? errors['Citta'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** PROVINCE */}
        <Controller
          rules={{ required: 'Campo obbligatorio' }}
          control={control}
          name="Provincia"
          render={({ onChange }) => (
            <Select
              className="form-group__select"
              label="Provincia"
              name="Provincia"
              options={provinceItaliane}
              handleChange={(value) => onChange(value)}
              error={errors['Provincia'] ? errors['Provincia'].message : ''}
              required
              inputRef={register()}
            />
          )}
        />

        {/** COMUNE */}
        <TextFieldCustom
          type="text"
          label="Comune"
          name="Comune"
          className="form-group__textfield"
          required
          error={errors['Comune'] ? errors['Comune'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** PRIVACY POLICY */}
        <div className="paragraph-small" dangerouslySetInnerHTML={{__html: disclaimer}} />
        <div className="form-group__privacy">
          {/** SUBMIT BUTTON */}
          <Button type="submit" kind="primary" disabled={loadingOnSubmit.disabled} label={loadingOnSubmit.label} color="brand" />
        </div>
      </div>
    </form>
  );
};

FormsPage.defaultProps = {
  disclaimer:
    '          <strong>Informativa ex art.13, GDPR</strong>\n' +
    '\n' +
    '          <p>Titolare del trattamento dei dati è il Comitato Italiano per l’UNICEF - Fondazione ONLUS , Via Palestro 68, 00185 Roma (RM).\n' +
    '            I dati personali saranno trattati con modalità prevalentemente elettroniche per le seguenti finalità:</p>\n' +
    '          <ul>\n' +
    '            <li>a) Inviare il materiale richiesto e/o dare riscontro alle richieste avanzate per l’adesione al Percorso di interesse</li>\n' +
    '            <li>b) Ottemperare a norme di legge o regolamento</li>\n' +
    '            <li>c) Fornire informazioni su iniziative/programmi di sensibilizzazione e promozione dei diritti dei bambini</li>\n' +
    '          </ul>\n' +
    '          <p>Per le finalità ai punti a) e b), il trattamento dei dati è ammesso senza il consenso dell’interessato ai sensi dell’art. 6 comma 1, lett. b) e c)\n' +
    '            GDPR; i dati saranno conservati per il tempo necessario a rispondere alle richieste e per eventuali contatti di approfondimento che permettano di\n' +
    '            valutare se aderire all’ iniziativa di interesse; in ogni caso per il periodo consentito dalla legge per esigenze di tutela legale. Per le finalità al\n' +
    '            punto c) il trattamento è ammesso ai sensi dell’art. 6 comma 1 lettera f) GDPR (“legittimo interesse”); i dati verranno conservati per il periodo\n' +
    '            consentito dalla legge per esigenze di tutela legale; la conservazione può essere di tempo inferiore se non si ha più\n' +
    '            interesse ad essere informati e lo si comunica con le modalità sotto riportate.</p>\n' +
    '          <p>Per i predetti fini saranno conservati anche successivamente, laddove leggi, regolamenti o normativa comunitaria ne determinino\n' +
    '            la conservazione per tempi differenti. Inoltre, saranno conservati in caso di imposizione da parte delle Forze dell’Ordine,\n' +
    '            della Magistratura e Organi di Controllo e per far valere o difendere diritti in sede giudiziaria. Le persone autorizzate al trattamento sono\n' +
    '            gli addetti all’amministrazione e organizzatori dell’iniziativa, alle attività istituzionali e statutarie, dei sistemi informativi e di sicurezza dei dati.</p>\n' +
    '          <p>Ai sensi degli artt. 15-22, GDPR, scrivendo all’e-mail <a href="mailto:infoprivacy@unicef.it">infoprivacy@unicef.it</a>,\n' +
    '            si può richiedere l’elenco completo e aggiornato dei responsabili del trattamento, nonché esercitare i diritti di consultazione,\n' +
    '            modificazione, di cancellazione e oblio, limitazione del trattamento dei dati, portabilità dei dati o opporsi al loro trattamento. Inoltre,\n' +
    '            l’interessato ha diritto di presentare reclamo all’autorità di controllo – per l’Italia è il Garante per la protezione dei dati personali\n' +
    '            – <a href="https://www.garanteprivacy.it">www.garanteprivacy.it</a>, per far valere i propri diritti. Il Data Protection Officer\n' +
    '            è contattabile all’e-mail <a href="mailto:dpo@unicef.it">dpo@unicef.it</a>, per informazioni sul trattamento dei dati.</p>\n' +
    '\n' +
    '          Informativa completa al sito <a href="https://www.unicef.it/note-sulla-privacy">www.unicef.it/privacy</a>\n'
}

export default FormsPage;
